module.exports = __webpack_public_path__ + "static/media/py.6b530772.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/py.svg
// module id = 2195
// module chunks = 0